import React from "react"
import {
	DataTableCellAlphaNumeric,
	DataTableRow,
} from "@walmart-web/livingdesign-components"
import { FormattedNumber, useIntl } from "react-intl"
import { formatNumber } from "helpers/numbers"
import "./index.scss"

const psychographicsSegment = "Psychographics segment"
const genderSegment = "Gender segment"
const GenerateRowsTableCustomerProfiling: React.FC<any> = ({ data }) => {
	const intl = useIntl()
	const renderRows = (row: Array<any>) => {
		return row.map((e: any, index: number) => {
			return (
				<DataTableRow key={e.id + index}>
					<DataTableCellAlphaNumeric>
						{e.id === psychographicsSegment ? (
							intl.formatMessage({
								id: `phronesis.customerbehavior.application.customerProfiling.metricsBySegments.${e.segment}`,
							})
						) : (
							<>
								{genderSegment === e.id
									? intl.formatMessage({
											id: `phronesis.customerbehavior.application.customerProfiling.metricsBySegments.table.${e.segment}`,
									  })
									: e.segment}
							</>
						)}
					</DataTableCellAlphaNumeric>
					<DataTableCellAlphaNumeric>
						<FormattedNumber
							value={e.participation}
							style={"percent"}
							minimumFractionDigits={1}
						/>
						<div className="variation-row">
							(
							<FormattedNumber
								value={e.varParticipation}
								style={"percent"}
								minimumFractionDigits={1}
							/>
							)
						</div>
					</DataTableCellAlphaNumeric>
					<DataTableCellAlphaNumeric>
						<FormattedNumber
							value={e.walmartParticipation}
							style={"percent"}
							minimumFractionDigits={1}
						/>
						<div className="variation-row">
							(
							<FormattedNumber
								value={e.varParticipationWalmart}
								style={"percent"}
								minimumFractionDigits={1}
							/>
							)
						</div>
					</DataTableCellAlphaNumeric>
					<DataTableCellAlphaNumeric UNSAFE_className="numeric">
						{formatNumber(e.customers, intl)}
						<div className="variation-row">
							(
							<FormattedNumber
								value={e.varCustomers}
								style={"percent"}
								minimumFractionDigits={1}
							/>
							)
						</div>
					</DataTableCellAlphaNumeric>
					<DataTableCellAlphaNumeric UNSAFE_className="numeric">
						{formatNumber(e.sales, intl)}
						<div className="variation-row">
							(
							<FormattedNumber
								value={e.varSales}
								style={"percent"}
								minimumFractionDigits={1}
							/>
							)
						</div>
					</DataTableCellAlphaNumeric>
					<DataTableCellAlphaNumeric UNSAFE_className="numeric">
						{formatNumber(e.purchaseFrequency, intl)}
						<div className="variation-row">
							(
							<FormattedNumber
								value={e.varPurchaseFrequency}
								style={"percent"}
								minimumFractionDigits={1}
							/>
							)
						</div>
					</DataTableCellAlphaNumeric>
					<DataTableCellAlphaNumeric UNSAFE_className="numeric">
						{formatNumber(e.spendByCustomer, intl)}
						<div className="variation-row">
							(
							<FormattedNumber
								value={e.varSpendByCustomers}
								style={"percent"}
								minimumFractionDigits={1}
							/>
							)
						</div>
					</DataTableCellAlphaNumeric>
					<DataTableCellAlphaNumeric UNSAFE_className="numeric">
						{formatNumber(e.avgTicket, intl)}
						<div className="variation-row">
							(
							<FormattedNumber
								value={e.varAvgTicket}
								style={"percent"}
								minimumFractionDigits={1}
							/>
							)
						</div>
					</DataTableCellAlphaNumeric>
					<DataTableCellAlphaNumeric UNSAFE_className="numeric">
						{formatNumber(e.itemsPurchased, intl)}
						<div className="variation-row">
							(
							<FormattedNumber
								value={e.varItemsPerVisit}
								style={"percent"}
								minimumFractionDigits={1}
							/>
							)
						</div>
					</DataTableCellAlphaNumeric>
					<DataTableCellAlphaNumeric>
						<FormattedNumber
							value={e.reach}
							style={"percent"}
							minimumFractionDigits={1}
						/>
						<div className="variation-row">
							(
							<FormattedNumber
								value={e.varReach}
								style={"percent"}
								minimumFractionDigits={1}
							/>
							)
						</div>
					</DataTableCellAlphaNumeric>
				</DataTableRow>
			)
		})
	}

	return <>{renderRows(data)}</>
}

export default GenerateRowsTableCustomerProfiling
